export default __webpack_public_path__ + "static/media/wellness-kit.c5ba88a6.png";